module.exports = window["wcBraintree"]["blockData"];